import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const updateUserdata = async (userId, newUserData) => {
  const token = sessionStorage.getItem('authToken');
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/update/${userId}/user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(newUserData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update current data');
    }

    return response.json();
  } catch (error) {
    console.error('Error updating current data:', error);
    throw error;
  }
};

export const updateUserImg = async ({ userId, profileImage }) => {
  const token = sessionStorage.getItem('authToken');

  const formData = new FormData();
  formData.append("profileImage", profileImage);

  const response = await fetch(
    `${api_base_url}/api/${api_key}/update/${userId}/userImg`,
    {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`
      },
      body: formData
    }
  );

  return response.json();
};
